import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
const FacilitiesNum = 6; // 每次显示数量
// 初始显示6个
$(".section1 ul li:lt(" + FacilitiesNum + ")").show();

$(".section1 .list-more").click(function () {
    const hidden = $(".section1 ul li:hidden"); // 找到隐藏的

    hidden.slice(0, FacilitiesNum).fadeIn(); // 显示6个

    // 如果全部显示完，隐藏按钮
    if ($(".section1 ul li:hidden").length == 0) {
        $(this).fadeOut();
    }
});

var content1 = new Swiper(".content1 .swiper", {
    pagination: {
        el: ".content1 .swiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
	},
	speed:800,
	loop:true,//必须
});

var content3 = new Swiper(".content3 .swiper", {
    pagination: {
        el: ".content3 .swiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
	},
	speed:800,
	loop:true,//必须
});

const ExhibitionNum = 3; // 每次显示数量
// 初始显示6个
$(".section3 ul li:lt(" + ExhibitionNum + ")").show();

$(".section3 .list-more").click(function () {
    const hidden = $(".section3 ul li:hidden"); // 找到隐藏的

    hidden.slice(0, ExhibitionNum).fadeIn(); // 显示6个

    // 如果全部显示完，隐藏按钮
    if ($(".section3 ul li:hidden").length == 0) {
        $(this).fadeOut();
    }
});

const VisitNum = 3; // 每次显示数量
// 初始显示6个
$(".section4 ul li:lt(" + VisitNum + ")").show();

$(".section4 .list-more").click(function () {
    const hidden = $(".section4 ul li:hidden"); // 找到隐藏的

    hidden.slice(0, VisitNum).fadeIn(); // 显示6个

    // 如果全部显示完，隐藏按钮
    if ($(".section4 ul li:hidden").length == 0) {
        $(this).fadeOut();
    }
});
